import { ImageGallery } from "./Gallery/Imagegallery";
import { SubServices } from '../../models/models';
import { allImages } from "../images";
var services = [
    {
        id: 0,
        image: ImageGallery.trailers.SemiLowBedTrailers[2].image,
        heading: "Trailers",
        tagline: "Tailored Trailers for Every Load – High, Semi-Low, and Low Bed Solutions!",
    },
    {
        id: 1,
        image: ImageGallery.cranes.AllTerrainCranes[9].image,
        heading: "Cranes",
        tagline: "Powerful All-Terrain Cranes and More – Engineered for Every Transport Need!"
    },
    {
        id: 2,
        image: allImages.axle,
        heading: "Axles",
        tagline: "Versatile Axle Solutions – 2, 3, 4 and 6 Axles Built for Every Transport Challenge!"
    },
    {
        id: 3,
        image: allImages.forklift,
        heading: "Forklifts & Manlifts",
        tagline: "Forklifts and Manlifts – Precision Equipment for Every Transportation Task!"
    }
];

const subServices: { [key: number]: SubServices[] } =
{
    0: [
        {
            id: 0,
            heading: "High Bed trailer",
            content: 'PBL has a fleet of 70 trailers of 22 MT, 30 MT, 40 MT, and 100 MT capacity with attachments of dollies and multi-tiered floating axles for cargo carriage. Unique specifications for cargo transportation at PBL Transport Corporation Private Limited make it the right choice for large corporate houses.',
            image: allImages.high,
            reverse: false,
            navigate: '/catalog?id=0&type=trailers'
        },
        {
            id: 1,
            heading: "Semi Low Bed Trailer",
            content: 'PBL has a fleet of 70 trailers of 22 MT, 30 MT, 40 MT, and 100 MT capacity with attachments of dollies and multi-tiered floating axles for cargo carriage. Unique specifications for cargo transportation at PBL Transport Corporation Private Limited make it the right choice for large corporate houses.',
            image: allImages.semi,
            reverse: true,
            navigate: '/catalog?id=1&type=trailers'
        },
        {
            id: 2,
            heading: "Low Bed Trailer",
            content: 'PBL has a fleet of 70 trailers of 22 MT, 30 MT, 40 MT, and 100 MT capacity with attachments of dollies and multi-tiered floating axles for cargo carriage. Unique specifications for cargo transportation at PBL Transport Corporation Private Limited make it the right choice for large corporate houses.',
            image: allImages.low,
            reverse: false,
            navigate: '/catalog?id=2&type=trailers'
        },
    ],
    1: [
        {
            id: 0,
            heading: "Pick and Carry Hydraulic Cranes",
            content: 'Pick and carry hydraulic cranes are versatile, mobile lifting machines designed for transporting heavy loads over short distances. Unlike stationary cranes, they combine lifting and carrying capabilities, making them ideal for construction sites, warehouses, and industrial projects.',
            image: allImages.pick,
            reverse: false,
            navigate: '/catalog?id=0&type=cranes'
        },
        {
            id: 1,
            heading: "All Terrain Cranes",
            content: "All-terrain cranes are powerful and versatile lifting machines designed to operate efficiently on both smooth roads and rough terrains. Combining the capabilities of a truck-mounted crane and a rough-terrain crane, they are perfect for projects that require mobility and flexibility across varying site conditions.",
            image: allImages.terrain,
            reverse: true,
            navigate: '/catalog?id=1&type=cranes'
        },
        {
            id: 2,
            heading: "Truck Mounted Cranes",
            content: "Truck-mounted cranes are versatile lifting machines equipped on a truck chassis, offering unmatched mobility and efficiency. Designed to handle various lifting and transportation tasks, they are widely used across industries for their convenience and cost-effectiveness.",
            image: allImages.truckMounted,
            reverse: false,
            navigate: '/catalog?id=2&type=cranes'
        },
        {
            id: 3,
            heading: "Chain-Mounted & Crawler-Mounted Cranes",
            content: "Chain-mounted cranes and crawler-mounted cranes are robust lifting machines designed for heavy-duty applications, often in environments where stability, power, and maneuverability are critical.",
            image: allImages.chained,
            reverse: true,
            navigate: '/catalog?id=3&type=cranes'
        },
        {
            id: 4,
            heading: "Mobile Tower Crane",
            content: "A mobile tower crane combines the features of a traditional tower crane with the mobility of a truck-mounted crane. It is widely used in construction sites where quick setup, flexibility, and high lifting capacities are required. Here's an overview",
            image: allImages.mobiletower,
            reverse: false,
            navigate: '/catalog?id=4&type=cranes'
        },
    ],
    2: [
        {
            id: 0,
            heading: "2 Axle",
            content: 'A 2-axle vehicle is any motor vehicle that has two axles, typically used for personal or commercial transportation. The axles are the central shafts that connect the wheels, enabling the vehicle to move efficiently.',
            image: allImages.axle2,
            reverse: false,
            navigate: '/catalog?id=0&type=axles'
        },
        {
            id: 1,
            heading: "3 Axle",
            content: '3-axle vehicle has three axles, meaning it has six or more wheels. These vehicles are designed to carry heavier loads and are commonly used for commercial, industrial, or public transport purposes.',
            image: allImages.axle3,
            reverse: true,
            navigate: '/catalog?id=1&type=axles'
        },
        {
            id: 2,
            heading: "4 Axle",
            content: '4-axle vehicle has four axles, meaning it has eight or more wheels. These vehicles are designed to carry heavier loads and are commonly used for commercial, industrial, or public transport purposes.',
            image: allImages.axle4,
            reverse: false,
            navigate: '/catalog?id=2&type=axles'
        },
        {
            id: 3,
            heading: "6 Axle",
            content: '6-axle vehicle is a heavy-duty transport vehicle with six axles, typically featuring 12 or more wheels. These vehicles are designed to handle extremely heavy loads, making them essential for industries like logistics, construction, and mining.',
            image: allImages.axle6,
            reverse: true,
            navigate: '/catalog?id=3&type=axles'
        },
    ],
    3: [
        {
            id: 0,
            heading: "Forklifts",
            content: "Forklifts are essential tools in modern logistics, manufacturing, and warehousing. Designed to enhance productivity, they provide efficient solutions for lifting, moving, and stacking heavy loads with precision. With various models available, from electric forklifts to internal combustion (IC) options, businesses can choose the perfect machine to suit their operational requirements.",
            image: allImages.fork,
            reverse: false,
            navigate: '/catalog?id=0&type=lifts'
        },
        {
            id: 1,
            heading: "Manlifts",
            content: "Manlifts are essential equipment for industries that require safe and efficient access to elevated work areas. Designed to support tasks in construction, maintenance, warehousing, and more, manlifts provide stability, mobility, and safety for workers operating at height. With various types available, including scissor lifts, boom lifts, and vertical mast lifts, you can choose the ideal solution for your specific needs.",
            image: allImages.manlift,
            reverse: true,
            navigate: '/catalog?id=1&type=lifts'
        },
    ]
};

export {services,subServices}